/**
 * Utility functions for handling localStorage operations
 */

import { logError } from '@rs-core/utils/logger';

export const setLocalStorageItem = (key, value) => {
	try {
		localStorage.setItem(key, JSON.stringify(value));
	} catch (error) {
		logError('setLocalStorageItem', `Error setting localStorage item for key "${key}":`, error);
	}
};

export const getLocalStorageItem = (key, defaultValue = null) => {
	try {
		const item = localStorage.getItem(key);
		return item ? JSON.parse(item) : defaultValue;
	} catch (error) {
		logError('getLocalStorageItem', `Error getting localStorage item for key "${key}":`, error);
		return defaultValue;
	}
};

export const removeLocalStorageItem = key => {
	try {
		localStorage.removeItem(key);
	} catch (error) {
		logError('removeLocalStorageItem', `Error removing localStorage item for key "${key}":`, error);
	}
};
